import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { notificationHandler } from 'utils/utils';
import { axiosSSO } from 'config';
import { roleMenagmentActions } from './roleMenagmentSlice';
import { roleMenagmentFormSaga } from '../formControlSlice/roleMenagmentFormSaga';
import { homeActions } from '../homePageSlice/homePageSlice';

export function* onSubmitFormStart() {
    yield takeLatest(roleMenagmentActions.submitFormStart, roleMenagmentFormSaga);
}

export function* deleteRole({ payload: dataPayload }) {
    try {
        const response = yield axiosSSO.delete(`/role/delete/${dataPayload.id}`);

        if (response.data.code === 'DELETED') {
            yield notificationHandler({ title: 'Successfully removed role', variant: 'success' });
            yield put(homeActions.fetchRolesStart());
        }
    } catch (err) {
        yield notificationHandler({ title: 'Error removing role' });
    }
}

export function* onDeleteRole() {
    yield takeEvery(roleMenagmentActions.deleteRole, deleteRole);
}

export function* roleMenagmentSaga() {
    yield all([call(onSubmitFormStart), call(onDeleteRole)]);
}
